import { motion } from "framer-motion";
import { Reveal, StaggerGroup, fadeUp } from "@/components/motion/Reveal";
import SectionHeading from "@/components/SectionHeading";
import Icon from "@/components/Icon";
import { INDUSTRIES } from "@/data/site";

export default function Industries() {
  return (
    <section className="section-pad" data-testid="industries-section">
      <div className="container-sky grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        <div>
          <SectionHeading
            eyebrow="Industries & Environments"
            title="Different Workplaces, Different Risk Profiles"
          />
          <Reveal delay={0.1}>
            <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
              SKY adapts its recommendations according to the client's industry, workforce, workplace
              hazards, regulatory obligations, existing systems, business requirements and available
              resources. No two workplaces are the same — and our advice reflects that.
            </p>
          </Reveal>
        </div>

        <StaggerGroup className="grid grid-cols-2 gap-4 sm:grid-cols-3">
          {INDUSTRIES.map((ind) => (
            <motion.div
              key={ind.name}
              variants={fadeUp()}
              className="group flex flex-col items-start gap-4 rounded-2xl border border-slate-100 bg-white p-6 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(10,126,201,0.12)]"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand/10 text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                <Icon name={ind.icon} className="h-6 w-6" />
              </span>
              <span className="text-sm font-bold text-navy">{ind.name}</span>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
